var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsEmoji2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0699 12.9601C12.6899 12.9601 13.1999 12.4501 13.1999 11.8301C13.1999 11.2101 12.6899 10.7001 12.0699 10.7001C11.4499 10.7001 10.9399 11.2101 10.9399 11.8301C10.9399 12.4501 11.4499 12.9601 12.0699 12.9601Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 11.8301C18.8 12.4501 19.31 12.9601 19.93 12.9601C20.55 12.9601 21.06 12.4501 21.06 11.8301C21.06 11.2101 20.55 10.7001 19.93 10.7001C19.3 10.7001 18.8 11.2101 18.8 11.8301Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 3.31006C9.00006 3.31006 3.31006 9.00006 3.31006 16.0001C3.31006 23.0001 9.01006 28.6901 16.0001 28.6901C22.9901 28.6901 28.6901 23.0001 28.6901 16.0001C28.6901 9.00006 23.0001 3.31006 16.0001 3.31006ZM16.0001 27.7501C9.52006 27.7501 4.25006 22.4801 4.25006 16.0001C4.25006 9.52006 9.52006 4.25006 16.0001 4.25006C22.4801 4.25006 27.7501 9.52006 27.7501 16.0001C27.7501 22.4801 22.4801 27.7501 16.0001 27.7501Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3202 18.9701C22.2102 18.9001 22.0902 18.8801 21.9702 18.9101C21.8502 18.9401 21.7402 19.0101 21.6802 19.1201C20.4402 21.0801 18.3202 22.2501 16.0102 22.2501C13.7002 22.2501 11.5802 21.0801 10.3402 19.1201C10.2702 19.0101 10.1702 18.9401 10.0402 18.9101C10.0002 18.9001 9.97016 18.9001 9.93016 18.9001C9.84016 18.9001 9.76016 18.9301 9.68016 18.9701C9.46016 19.1101 9.39016 19.4001 9.53016 19.6201C10.9402 21.8601 13.3602 23.1901 16.0002 23.1901C18.6402 23.1901 21.0602 21.8601 22.4702 19.6201C22.6002 19.4001 22.5402 19.1101 22.3202 18.9701Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsEmoji2023);
export default __webpack_public_path__ + "static/media/beemg-icons-emoji-2023.febca177f95462f0353006d200a2232d.svg";
export { ForwardRef as ReactComponent };